import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';
import SelectFild from '../../../../../components/SelectFild/SelectFild';

const AepResponse = ({ details, selectedCheckboxes, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const initialValues = {
        id: '',
        emergencyNature: "",
        emergencyLevel: "",
        timeDeclared: "",
        agenciesInvolved: "",
        evacuationRequired: "",
        peopleAffected: "",
    };

    useEffect(() => {
        if (details?.what_occurred?.details?.["4"]?.[0]) {
            const detailItem = details.what_occurred.details["4"][0];
            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};

            setPreImg(detailItem.image_json);

            formik.setValues({
                id: detailItem.id || '',
                emergencyNature: parsedData.emergencyNature || '',
                emergencyLevel: parsedData.emergencyLevel || '',
                timeDeclared: parsedData.timeDeclared || '',
                agenciesInvolved: parsedData.agenciesInvolved || '',
                evacuationRequired: parsedData.evacuationRequired || '',
                peopleAffected: parsedData.peopleAffected || '',
            });
        }
    }, [details]);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const selectedCatList = JSON.stringify(selectedCheckboxes);
            let param = {
                "agenciesInvolved": values.agenciesInvolved,
                "emergencyLevel": values.emergencyLevel,
                "emergencyNature": values.emergencyNature,
                "evacuationRequired": values.evacuationRequired,
                "peopleAffected": values.peopleAffected,
                "timeDeclared": values.timeDeclared,
            };

            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["4"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 4;
            const sub_category = selectedCheckboxes["4"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));

            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });

            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                console.log("res", res.data);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }

        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;
    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };
    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="GroupList fieldset">
                        <div className='toggle-button'>
                            <h2 className="listTitle">AEP Emergency Response</h2>
                            <div className="btnColaps">
                                <FaChevronUp />
                            </div>
                        </div>

                        <div className="subFilds">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Nature of Emergency</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="emergencyNature"
                                            value={values.emergencyNature}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Level (Full / Standby / Medical)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="emergencyLevel"
                                            value={values.emergencyLevel}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Time Declared</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="timeDeclared"
                                            value={values.timeDeclared}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Agencies Involved (Fire, Medical, Police)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="agenciesInvolved"
                                            value={values.agenciesInvolved}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group" data-id=".VehicleAircraft">
                                        <label>Was Evacuation Required?</label>
                                        <SelectFild
                                            Firstop='Select Was Evacuation Required?'
                                            selectName="evacuationRequired"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.evacuationRequired}
                                            onChange={(selectedOption) => setFieldValue("evacuationRequired", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.evacuationRequired && touched.evacuationRequired && (
                                            <p className="errormsg">{errors.evacuationRequired}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Number of People Affected</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="peopleAffected"
                                            value={values.peopleAffected}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <UploadWithSignature onFilesChange={setUploadedFiles} />

                            <div className='previewsimges'>
                                {preImg.map((fileUrl, index) => {
                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div key={index} className='imageboxs'>
                                                <div className='imgs pdfs'>
                                                    <div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                        </div>
                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs'>
                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="button-boxs grid pt-2 pb-2">
                                <button type='submit' onClick={handleSubmit} className='btn btn-orange'>Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default AepResponse